import { React } from '@common/3rd';
import { PATH, Apis, Storage } from '@common';
import { DeskPageBody } from '@desk-component';
import SignCommonPage from './sign-common';
import {
    DeskPanel,
    DeskPanelBody
} from '@desk-component';
import Alert from '@alert';
import { smsCount, errTimesForTriggerCaptcha } from '../const';
import { ButtonType } from '@my-types';

class ResetPasswordPage extends SignCommonPage {
    constructor(props: any, context: any) {
        super(props, context);
        this.state = {
            mobile: '',
            validateCode: '',
            password: '',
            confirmPassword: '',
            canSend: true,
            count: smsCount,
            errorMsg: {},
            validCaptchaCode: false, // 发送验证码超过5次 是否校验图形验证码
            captchaCode: '', // 发送验证码超过5次出现的图形验证码值
            // validateCodeErrTimes: 0, // 验证码输错3次出现图形验证码
            captchaCodeForErrTimes: '', // 验证码输错3次出现的图形验证码值
            disabled: false
        }
    }
    protected getHtmlTitle(): string | null {
		return null;
	}
    isDisabled() {
        let fieldCheckList = Object.assign({}, this.fieldCheck);
        let disabled = Object.keys(fieldCheckList).some(key => !this.state[key]);
        return disabled;
    }
    componentDidUpdate(prevProps: any, prevState: any) {
        let disabled = this.isDisabled();
        if (prevState.disabled !== disabled) {
            this.setState({
                disabled: disabled
            });
        }
    }
    renderPageBody() {
        const C = this.getComponents();
        return <DeskPageBody css={() => `background: #fff;`}>
            <C.FormBox>
                <h1>重置密码</h1>
                <DeskPanel>
                    <DeskPanelBody>
                        {this.renderFormBody(C)}
                        <C.Row css={() => `margin-top:20px;`}>
                            <C.Button type={ButtonType.PRIMARY} disabled={this.state.disabled} onClick={this.onResetPassword}>
                                重置密码
                            </C.Button>
                            <C.Button type={ButtonType.DEFAULT} css={() => `margin-left:20px;`}
                                    onClick={() => {
                                        let organQuery = Storage.Last.session().get('organQuery');
                                        let redirectPath = organQuery?.originVendor ? `${PATH.DESK2_SIGN_IN_VENDOR.replace(':vendor', encodeURIComponent(organQuery.originVendor))}` : PATH.DESK2_SIGN_IN;
                                        this.getHelpers().getRouter().pushRedirect(redirectPath);
                                    }}>
                                去登录
                            </C.Button>
                        </C.Row>
                    </DeskPanelBody>
                </DeskPanel>
            </C.FormBox>
        </DeskPageBody>
    }
    protected onResetPassword = async () => {
        let fieldCheckList = Object.assign({}, this.fieldCheck);
        for await (let key of Object.keys(fieldCheckList)) {
            this.onBlur(fieldCheckList, key)
        }
        console.log('after on blur errormsg', this.state.errorMsg)
        if (Object.values(this.state.errorMsg).some((errors:any) => !!errors.length)) {
            return;
        }
        if (this.state.password === this.state.mobile) {
            Alert.error('密码不能与手机号相同！');
            return;
        }
        let params = {
            password: this.state.password,
            confirmPassword: this.state.confirmPassword,
            validateCode: this.state.validateCode,
            tenantCode: this.tenantCode,
            mobile: this.state.mobile
        }
        try {
            let res = await this.getHelpers().getAjax().post(Apis.RESET_PWD2, params, { loading: true })
            console.log('create account result', res)
            Alert.success('重置成功').then(() => {
                let organQuery = Storage.Last.session().get('organQuery');
                let redirectPath = organQuery?.originVendor ? `${PATH.DESK2_SIGN_IN_VENDOR.replace(':vendor', encodeURIComponent(organQuery.originVendor))}` : PATH.DESK2_SIGN_IN;
                this.getHelpers().getRouter().pushRedirect(redirectPath);
            });
        } catch (e) {
            console.log('reset password error', e)
            Alert.hide();
            if (e?.body?.errors && e.body.errors.length) {
                if (e.body.errors[0].code === 'VERIFICATION_ERROR') {
                    // this.setState({
                    //     validateCodeErrTimes: this.state.validateCodeErrTimes + 1
                    // });
                    Storage.Last.session().set('validateCodeErrTimesResetPwd', ~~Storage.Last.session().get('validateCodeErrTimesResetPwd') + 1);
                    Alert.error(e.body.errors[0].description).then(() => {
                        if (Storage.Last.session().get('validateCodeErrTimesResetPwd') >= errTimesForTriggerCaptcha) {
                            this.triggerCaptcha((captchaCode: string) => {
                                this.setState({ captchaCodeForErrTimes: captchaCode });
                            });
                        }
                    });
                } else {
                    Alert.error(e.body.errors[0].description);
                }
            }
        } finally {
        }
    }
    async componentDidMount() {
        super.componentDidMount();
    }
}
export default ResetPasswordPage;